import { put, SagaGenerator, select, takeLatest } from "typed-redux-saga";
import { Action, AnyAction } from "typescript-fsa";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { NEW_INSTANCE_IDENTIFIER } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormActivity, FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

export function* deleteSaga(): SagaGenerator<void> {
	yield* takeLatest((action: AnyAction) => {
		return (
			FormEngineActions.event.match(action) &&
			Events.eventButton.match(action.payload.engineEvent) &&
			["event_delete"].includes(action.payload.engineEvent.payload.name)
		);
	}, handle);
}

function* handle(action: Action<FormEngineActions.FormEngineEventActions>): SagaGenerator<void> {
	const activity = yield* select(ActivitySelectors.activityById(action.payload.activityId));
	const data = yield* select(ActivitySelectors.data(action.payload.activityId));

	const initiatingActivityId = activity?.initiatingActivityId;

	if (!initiatingActivityId || !data || !FormActivity.Data.SingleDocumentData.isInstance(data)) {
		return;
	}

	if (data.document.id === NEW_INSTANCE_IDENTIFIER) {
		yield* put(
			FormEngineActions.event({
				activityId: activity.id,
				engineEvent: Events.eventButton({
					buttonPath: [],
					name: "event_cancel"
				})
			})
		);

		return;
	}

	yield* put(
		ActivityActions.create({
			activityDescriptor: {
				modal: "Loeschen",
				overviewId: initiatingActivityId,
				instance: data.document.id
			},
			loadingState: "without"
		})
	);
}
